// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2k_zu","right":"styles_right__51jF1"};